const getLangValue = (languageValue, env) => {
  const lang = process.env[env || 'REACT_APP_LANGUAGE'] || 'RU';

  return languageValue[lang.toLowerCase()] || '';
}

export default getLangValue;